import React from 'react';
import phone from './pics/phone.png'
import mail from './pics/email.png'
// import addres from './pics/location.png'
import linkedin from './pics/linkedin.png'
import './css/Contact.css';
import ContactForm from './ContactForm';
import ContactFormM from './ContactFormM';
// import { Link } from 'react-router-dom';
// import ContactForm from '../ContactForm';
// import { useState } from 'react';


const Contact = ({ language, toggleLanguage,isMobile}) => {

return (
  <>
  <h1 style={{paddingLeft: '30px',color: '#24569b'}}>{language === 'en' ? 'Contact Us' : 'Kontaktirajte Nas'}</h1>
<div className="container" style={{padding: '40px',borderRadius: '15px',marginTop: '30px'}}>

  {/*Kontak informacije*/}
    <div className='my-div razmakContact'>

<h2 className= 'hPadd' >
  {isMobile ? (
  <b style={{fontSize: '30px'}}>Gligorije Borocki <i style={{fontSize: '22px'}}><br/>
    {language === 'en' ? '(General Manager)' : '(Generalni Direktor)'}</i></b>
  ) : (
    <b style={{fontSize: '30px'}}>Gligorije Borocki <i style={{fontSize: '22px'}}>
    {language === 'en' ? '(General Manager)' : '(Generalni Direktor)'}</i></b>
  )}

<br /><br/>
{/* Generalni direktor */}
                <p style={{'paddingBottom': !isMobile ? '30px' : '5px',paddingRight: '20px',}}> 
                <i style={{ display: 'inline-block', width: '35px', height: '28px', lineHeight: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <img title='mail' src={mail} alt='mail' style={{ width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle'}}/></i>
                  <span className="paddin shrinkTxt" style={{'fontSize': isMobile ? '16px':'19px'}}>office.powermax@gmail.com</span><br/>
                <span className="paddin shrinkTxt" style={{'fontSize': isMobile ? '16px':'19px'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;gile.borocki@gmail.com</span>
                </p>
                 {/* bobanradonic@gmail.com */}

                <p style={{'paddingBottom': !isMobile ? '30px' : '5px'}}> 
                {/* <i><img title='fon' src={phone} alt='phone' style={{width: '30px', height: '30px', marginRight: '5px'}}/></i> */}
                <i style={{ display: 'inline-block', width: '35px', height: '28px', lineHeight: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
    <img src={phone} alt='phone' style={{ width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle' }} />
</i>
                <span className="paddin" style={{fontSize: 'smaller'}}>+381 60 33-77-946</span>
                </p>
                {/* +381 60 02-02-02-8  dodaj link ka linkedinu*/}

                <p style={{'paddingBottom': !isMobile ? '30px' : '5px'}}> 
                <i style={{ display: 'inline-block', width: '35px', height: '28px', lineHeight: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <a href="https://www.linkedin.com/in/gligorije-borocki-30574b20a/?originalSubdomain=rs"   target="_blank" rel="noopener noreferrer" >
                <img title='linkedin' src={linkedin} alt='linkedin' style={{ width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle'}}/>
                </a></i>
                <span className="paddin"><a style={{textDecoration: 'none',color: '#24569b'}}
  href="https://www.linkedin.com/in/gligorije-borocki-30574b20a/?originalSubdomain=rs" 
  target="_blank" 
  rel="noopener noreferrer"
>Gligorije Borocki</a></span>
                </p>

                <br />

</h2>
</div>

<div className='my-div' style={{'margin': isMobile ? '0px 5px' : '0px 50px'}}>

<h2 className= 'hPadd' >
  {isMobile ? (
  <b style={{fontSize: '30px'}}>Slobodan Radonić <i style={{fontSize: '22px'}}><br/>
    {language === 'en' ? '(Technical Director)' : '(Tehnicki Direktor)'}</i></b>
  ) : (
    <b style={{fontSize: '30px'}}>Slobodan Radonić <i style={{fontSize: '22px'}}>
    {language === 'en' ? '(Technical Director)' : '(Tehnicki Direktor)'}</i></b>
  )}
<br /><br/>
{/* Tehnicki direktor */}
                <p style={{'paddingBottom': !isMobile ? '30px' : '5px',paddingRight: '15px'}}> 
                <i style={{ display: 'inline-block', width: '35px', height: '28px', lineHeight: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <img title='mail' src={mail} alt='mail' style={{ width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle'}}/></i>
                <span className="paddin shrinkTxt" style={{'fontSize': isMobile ?  '16px' : '19px'}}>office.powermax@gmail.com</span><br/>
                <span className="paddin shrinkTxt" style={{'fontSize': isMobile ? '16px':'19px'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;bobanradonic@gmail.com</span>
                
                </p>
                 

                <p style={{'paddinBottom': !isMobile ? '30px' : '5px'}}> 
                {/* <i><img title='fon' src={phone} alt='phone' style={{width: '30px', height: '30px', marginRight: '5px'}}/></i> */}
                <i style={{ display: 'inline-block', width: '35px', height: '28px', lineHeight: '10px', textAlign: 'center', verticalAlign: 'middle' }}>
    <img src={phone} alt='phone' style={{ width: '100%', height: '100%', objectFit: 'contain', verticalAlign: 'middle' }} />
</i>
<span className="paddin" style={{fontSize: 'smaller'}}>+381 60 02-02-02-8</span> 
                </p>                
                {/* <p style={{paddingBottom: '20px'}}> 
                <i><img title='linkedin' src={linkedin} alt='linkedin' style={{width: '30px', height: '30px', marginRight: '5px'}}/></i>
                <span className="paddin">Slobodan Radonic</span>
                </p> */}
                {/* linkedin linkove ubaciti  */}
                <p><div style={{display: 'flex', paddingBottom: '30px'}}>
                <i>&nbsp;</i>
                <span>&nbsp;</span>
                </div>
                </p>

                <br />

</h2>
</div>

  {/*Upit Forma*/}

  {/* <div className='my-div' style={{'margin': isMobile ? '0px 5px' : '50px 50px',background:'none',border:'none',padding:'0px',borderRadius:'65px'}}>
    <div className='upit'>
      <h2 style={{display: 'flex', justifyContent: 'center'}}>{language === 'en' ? 'Direct Contact' : 'Direktan Kontakt'}</h2>
      <form>
        <label htmlFor="username">{language === 'en' ? 'Name' : 'Ime'}:</label><br/>
        <input type="text" id="username" name="username" placeholder={language === 'en' ? 'Name' : 'Ime'} /><br/>
        <label htmlFor="email">E-mail:</label><br/>
        <input type="email" id="email" name="email" cols="40" placeholder={language === 'en' ? "Your mail" : 'Vaš mail'} /><br/>
        <label htmlFor="comments">{language === 'en' ? 'Message' : 'Poruka'}:</label><br/>
        <textarea id="comments" name="comments" rows="4" cols="40" placeholder={language === 'en' ? "Your message" : 'Vaš upit'}></textarea>
        <button className='button' type="submit">{language === 'en' ? 'Send' : 'Pošalji'}</button>
      </form>
    </div>
</div> */}
    </div>
    {isMobile ? (
<ContactFormM language={language}/> ):(
  <ContactForm language={language}/>
)}



<br/>
</>
);

  };
  
  export default Contact;
  